import ImageClass from "../../src/shell/Image";
import { jump } from "../../src/shell/jump";
import { mc } from "../characters/MC";
import { doTransition, doWaitImageByTime } from "../helpers/helpers";
import { images } from "./images";
import { V8EmilyKissThoughtsAfter } from "./V8";

export const V8EmilyKissThoughts = async (): Promise<any> => {
    doTransition(images.v8.MCRoomAfterEmily_0);
    mc.think(`It must be a dream. No way that just happened!`);
    mc.think(`What the fuck?`);
    doWaitImageByTime(images.v8.MCRoomAfterEmily_1);
    mc.think(`Did she do it on purpose?`);
    mc.think(`No way she did it on purpose! She was barely awake when I carried her to bed.`);
    doWaitImageByTime(images.v8.MCRoomAfterEmily_2);
    mc.think(`But what if she did?`);
    mc.think(`She must have thought I was someone else... Maybe her ex? She keeps talking about him.`);
    doWaitImageByTime(images.v8.MCRoomAfterEmily_0);
    mc.think(`Surely she was thinking she was in a different place...`);

    mc.think(`But what if she did mean it?`);
    doWaitImageByTime(images.v8.MCRoomAfterEmily_1);
    mc.think(`What am I supposed to do now? Should I act like everything is normal...? Should I bring it up?`);
    mc.think(`No! Don't be stupid ${mc.name}. You gotta act normally... Let her bring it up.`);
    doWaitImageByTime(images.v8.MCRoomAfterEmily_0);
    mc.think(`If she remembers...`);

    doWaitImageByTime(images.v8.MCRoomAfterEmily_2);
    mc.think(`I better try and get some sleep... Though my mind is racing... that kiss.`);


    return jump(V8EmilyKissThoughtsAfter, "V8EmilyKissThoughtsAfter");
};